// lib/styles/colors.ts
var Colors = {
  // メインカラー
  Main100: "#005FAA",
  // ボタン・タグ、ラベル・リンク
  Main20: "#CCDFEE",
  // テーブルヘッダー, disabledカラー
  Main10: "#E5EFF7",
  Main05: "#F2F7FB",
  Main: "#485FC7",
  MainBlack: "#004276",
  // Activeカラー
  // ベースカラー
  Gray100: "#000E1A",
  // ベースのテキスト
  Gray90: "#1A2631",
  Gray80: "#333E48",
  Gray60: "#666E76",
  // タグ・ラベル
  Gray50: "#80868C",
  Gray40: "#999FA3",
  // サブテキスト・テーブル内羅線・activeカラー
  Gray30: "#B3B7BA",
  Gray20: "#CCCFD1",
  Gray10: "#E5E7E8",
  // ボタン
  Gray5: "#F2F3F4",
  // 背景・テーブル内小見出し
  White: "#FFFFFF",
  // 背景・ベタ背景に乗せるテキスト
  Gray: "#333",
  // アクセントカラー
  Accent100: "#DB2223",
  // ボタン・タグ、ラベル・破壊、削除リンク・必須表示
  Accent10: "#FBE9E9",
  // エラー背景・disabledカラー
  AccentBlack: "#8C1B20",
  // Activeカラー
  Purple80: "#BC41B1",
  // タグ、ラベル（推奨）
  // 文字色が黒のもの
  BlueGreen60: "#6BD4CA",
  // タグ、ラベル（推奨）
  Green60: "#66D48B",
  // タグ、ラベル（推奨）
  Yellow100: "#F7CC19",
  Yellow60: "#FAE075",
  // タグ、ラベル
  Yellow10: "#FEFAE8",
  // テーブル内アクセント
  Orange100: "#FC9C0D",
  // タグ、ラベル（推奨）
  Orange70: "#FDBA56"
  // タグ、ラベル（推奨）
};

export {
  Colors
};
